// extracted by mini-css-extract-plugin
export default {"text":"BrandingAndChipping_text__6E4sV","h1":"BrandingAndChipping_h1__ZI0HU","h2":"BrandingAndChipping_h2__PQ+IK","h3":"BrandingAndChipping_h3__0gsVl"};